"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateProductUrl = exports.slugify = void 0;
const tooManyHyphensRegex = /-{2,}/g;
const MAX_SLUG_LENGTH = 36;
const SLUG_CLEANING_REGEX = /[^\w\d\s-]|\b(a|and|of|the|with|for)\b|-?$/gi;
const PDPPath = 'https://www.chewy.com/:slug/dp/:id';
function slugify(text, clean = true, truncate = true) {
    const lowerCaseText = text.toLowerCase();
    let slugified = lowerCaseText
        .normalize('NFD')
        .replace(clean ? SLUG_CLEANING_REGEX : '', '')
        .split(/\s/)
        .filter((word) => word.trim() !== '')
        .join('-')
        .replace(tooManyHyphensRegex, '-')
        .replace(/^-/, '');
    if (lowerCaseText.startsWith('a ') || lowerCaseText.startsWith('a-')) {
        slugified = 'a-' + slugified;
    }
    if (truncate) {
        let truncatedSlug = '';
        slugified.split('-').every((word) => {
            if (truncatedSlug.length + word.length <= MAX_SLUG_LENGTH) {
                if (truncatedSlug !== '') {
                    truncatedSlug += '-';
                }
                truncatedSlug += word;
                return true;
            }
            else {
                return false;
            }
        });
        return truncatedSlug;
    }
    return slugified;
}
exports.slugify = slugify;
/**
 * This function supposed to be a backup for the PDP URL generation until SEO fully owns the URL structure.
 * Before that, it's recommended to use the `productUrl` field from the product object, which should be generated by PDP repo(s).
 *
 * @param slug
 * @param entryID
 * @returns
 */
const generateProductUrl = (slug, entryID) => {
    if (!entryID || !slug) {
        return undefined;
    }
    return PDPPath.replace(':slug', slug ?? 'product').replace(':id', entryID);
};
exports.generateProductUrl = generateProductUrl;
//# sourceMappingURL=url-generators.js.map